import type { Vacancy } from 'clients/AutoCompleteClient/types';
import type { Dispatch, SetStateAction } from 'react';
import type { IndeedProject } from 'shared/legacy/hooks/useBrowserExtension/indeed/useIndeedProjectListQuery';

export enum ActivateRobinJrDialogType {
  Activate = 'activate',
  Reactivate = 'reactivate',
}

export type ActivateRobinJrDialogProps = {
  handleOutreachModalRequestClose: () => void;
  onConfirmSelectedVacancy: () => void;
  isLoading: boolean;
  selectedAts: Vacancy | null;
  setSelectedAts: (ats: Vacancy | null) => void;
  isProcessingVacancy: boolean;
  type: ActivateRobinJrDialogType;
  dontShowMessagePreview?: boolean | null;
  setDontShowMessagePreview: Dispatch<SetStateAction<boolean | null>>;
  showMessagePreviewCheckbox?: boolean;
  dontShowWhatsAppMessagePreview?: boolean | null;
  setDontShowWhatsAppMessagePreview?: Dispatch<SetStateAction<boolean | null>>;
  showWhatsAppPreviewCheckbox?: boolean;
  dontShowQuestionnairePreview?: boolean | null;
  setDontShowQuestionnairePreview: Dispatch<SetStateAction<boolean | null>>;
  showQuestionnairePreviewCheckbox?: boolean;
  showNylasCalendarConnectionCheckbox?: boolean;
  selectedIndeedProject: IndeedProject | null;
  setSelectedIndeedProject: (project: IndeedProject | null) => void;
};
